module.exports = __webpack_public_path__ + "static/laptopWorkingDesktop-8fec112f338cf57ae947073e0445971e.png";